module.exports = __webpack_public_path__ + "static/media/home-pallate-image.4ed2cf57.png";